//librerias
import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-modal-confirmacion",
  templateUrl: "./modal-confirmacion.component.html",
})
export class ModalConfirmacionComponent {
  @Input() nombreUsuario!: string;
  @Output() Confirm = new EventEmitter();
  @Output() Close = new EventEmitter();

  confirm() {
    this.Confirm.emit();
  }

  close() {
    this.Close.emit();
  }
}
